import GroupRouter from './GroupAdmin'
import OperateAdmin from './OperateAdmin'
import SystemAdmin from './SystemAdmin'

const LayoutRouter:any = [
  GroupRouter,
  OperateAdmin,
  SystemAdmin

]

export default LayoutRouter
